/* EcommerceTab — Label Print Confirmation Dialog */
import React from 'react';
import { Loader2, Printer, X } from 'lucide-react';

export default function LabelPreviewDialog({ labelPreview, printingLabels, onClose, onConfirm }) {
    if (!labelPreview) return null;
    const isLoading = labelPreview === 'loading';
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" data-testid="label-print-modal">
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] flex flex-col">
                <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Printer size={18} className="text-cyan-700" />
                        <h3 className="text-base font-bold text-gray-900">Bol Kargo Etiketi — Onay</h3>
                    </div>
                    <button onClick={() => !isLoading && !printingLabels && onClose()}
                        className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-gray-100">
                        <X size={16} />
                    </button>
                </div>
                <div className="p-5 overflow-y-auto flex-1">
                    {isLoading ? (
                        <div className="text-center py-8 text-gray-500">
                            <Loader2 className="animate-spin mx-auto mb-3" size={28} />
                            Bol'dan kargo fiyatları çekiliyor...
                        </div>
                    ) : (
                        <>
                            {labelPreview.new_count > 0 ? (
                                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 text-xs text-amber-900">
                                    <b>💸 Önemli:</b> {labelPreview.new_count} YENİ etiket için Bol hesabından <b>{labelPreview.total_price?.toFixed(2)}€</b> çekilecek.
                                    {labelPreview.already_exists_count > 0 && (
                                        <> · <b>{labelPreview.already_exists_count} sipariş</b> için etiket zaten basılı (€0 - sadece yazdırılır).</>
                                    )}
                                </div>
                            ) : (
                                <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 mb-4 text-xs text-emerald-900">
                                    <b>✅ Para çekilmeyecek:</b> Tüm seçili siparişlerin etiketi zaten basılı. Sadece PDF'leri tekrar yazdırılacak.
                                </div>
                            )}
                            <div className="space-y-2 mb-4">
                                {labelPreview.items.map(i => (
                                    <div key={i.order_id}
                                        className={`flex items-center justify-between gap-2 p-2.5 rounded-lg text-xs ${
                                            !i.ok ? 'bg-rose-50 border border-rose-200'
                                                : i.already_exists ? 'bg-emerald-50 border border-emerald-200'
                                                    : 'bg-gray-50'
                                        }`}>
                                        <div className="min-w-0 flex-1">
                                            <div className="flex items-center gap-1.5">
                                                <span className="font-mono font-semibold text-gray-900">{i.order_id}</span>
                                                {i.already_exists && (
                                                    <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-emerald-600 text-white">MEVCUT</span>
                                                )}
                                            </div>
                                            {i.ok ? (
                                                <div className="text-[10px] text-gray-600 truncate">
                                                    {i.customer} {i.country && `(${i.country})`} · {i.label_name}
                                                </div>
                                            ) : (
                                                <div className="text-[10px] text-rose-700">⚠️ {i.error}</div>
                                            )}
                                        </div>
                                        {i.ok && (
                                            <div className="text-right shrink-0">
                                                <div className={`font-bold ${i.already_exists ? 'text-emerald-700' : 'text-gray-900'}`}>
                                                    {i.already_exists ? 'ÜCRETSİZ' : `${i.price.toFixed(2)} €`}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className={`flex items-center justify-between p-3 rounded-lg border ${
                                labelPreview.new_count > 0 ? 'bg-cyan-50 border-cyan-200' : 'bg-emerald-50 border-emerald-200'
                            }`}>
                                <div className={`text-sm font-semibold ${labelPreview.new_count > 0 ? 'text-cyan-900' : 'text-emerald-900'}`}>
                                    Toplam ({labelPreview.count} etiket):
                                </div>
                                <div className={`text-xl font-black ${labelPreview.new_count > 0 ? 'text-cyan-900' : 'text-emerald-900'}`}>
                                    {labelPreview.total_price.toFixed(2)} €
                                </div>
                            </div>
                            <div className="mt-3 text-[11px] text-gray-500 leading-relaxed">
                                ✓ Mevcut etiketler doğrudan PDF olarak indirilir, para çekilmez<br />
                                ✓ Yeni etiketler: Bol'a POST → process-status bekle → PDF<br />
                                ✓ Pick slip (paketleme listesi) PDF'in arkasına eklenir<br />
                                ✓ Tracking otomatik Bol'a bağlanır
                            </div>
                        </>
                    )}
                </div>
                {!isLoading && (
                    <div className="p-4 border-t border-gray-200 flex items-center justify-end gap-2">
                        <button onClick={onClose} disabled={printingLabels}
                            className="h-9 px-4 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg"
                            data-testid="label-cancel-btn">
                            İptal
                        </button>
                        <button onClick={onConfirm} disabled={printingLabels || labelPreview.count === 0}
                            className={`h-9 px-4 text-sm font-semibold text-white disabled:opacity-50 rounded-lg flex items-center gap-1.5 ${
                                labelPreview.new_count > 0 ? 'bg-cyan-700 hover:bg-cyan-800' : 'bg-emerald-700 hover:bg-emerald-800'
                            }`}
                            data-testid="label-confirm-btn">
                            {printingLabels ? <Loader2 size={14} className="animate-spin" /> : <Printer size={14} />}
                            {printingLabels
                                ? 'Bol çağrıları yapılıyor...'
                                : labelPreview.new_count > 0
                                    ? `Onayla ve Yazdır (${labelPreview.total_price?.toFixed(2)} €)`
                                    : `Yazdır (ücretsiz)`
                            }
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
